import { DashboardLayout, BaseLayout, SingleProperty } from "@layouts/index";

// import { TestimonialCardList } from "@lists/TestimonialCardList";

// import { testimonials } from "../Landing2/data";
// import { properties, testimonials } from './data';
import { useLocation } from "react-router";
import { PropertyListResponse } from "@interfaces/properties.interface";
import { useSessionStorage } from "../../hooks";
import { useEffect, useLayoutEffect, useState } from "react";
import { getProfile } from "@services/krent.service";
import { validateCurrentToken, clearAuthData } from "@utils/tokenUtils";
import { scheduleScrollToTop } from "@utils/scrollToTop";
import {
  getSingleListingProperty,
  getSingleProperty,
} from "@services/krent.service";
import { CTASection } from "components/CTASection";

export const Property = () => {
  const location: any = useLocation();
  const [user, setUser] = useSessionStorage("user", {});
  const [singleProperty, setSingleProperty] = useState<PropertyListResponse>();

  useEffect(() => {
    document.body.style.overflow = "auto";

    document.body.style.pointerEvents = "auto";
  }, []);
  useLayoutEffect(() => {
    return scheduleScrollToTop();
  }, [location.pathname, location.key]);

  useEffect(() => {
    const abort = new AbortController();
    if (!user?.id && validateCurrentToken()) {
      getProfile(abort.signal)
        .then((re: any) => setUser(re["data"]))
        .catch((e: any) => {
          console.error("Failed to fetch profile in Property page", e);
          clearAuthData();
        });
    }
    return () => abort.abort();
  }, [user, setUser]);

  useEffect(() => {
    const abortController = new AbortController();

    const fetchData = async () => {
      try {
        let res;
        if (location?.state?.property?.id) {
          const id = location.state.property.id;
          res = await getSingleListingProperty(id, abortController.signal);
        } else {
          const pathname = decodeURIComponent(location.pathname ?? "");
          const slug = pathname.match(/\/property\/(.+)$/)?.[1];
          if (!slug) {
            console.error("No slug found in pathname:", pathname);
            return;
          }
          res = await getSingleProperty(slug, abortController.signal);
        }

        setSingleProperty((res as any)?.data);
      } catch (err: any) {
        console.error(err?.errors?.[0]?.message || err);
      }
    };

    fetchData();

    return () => abortController.abort();
  }, [location?.state?.property?.id, location.pathname]);

  return user && user?.id ? (
    <DashboardLayout
      title="Explore"
      subtitle="Select and book property on krent"
    >
      <SingleProperty
        prop={location?.state?.property}
        singleProperty={singleProperty}
      />
    </DashboardLayout>
  ) : (
    <BaseLayout>
      <SingleProperty
        prop={location?.state?.property || singleProperty}
        singleProperty={singleProperty}
      />
      <CTASection />
    </BaseLayout>
  );
};
